import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

interface UseDeleteDashboardComponentsProps {
  dashboardId: string | undefined;
  dashboardComponentId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useDeleteDashboardComponents = ({
  dashboardId,
  dashboardComponentId,
  options,
}: UseDeleteDashboardComponentsProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['deleteDashboardComponent', dashboardComponentId],
    mutationFn: () => {
      return privateAxios.put(`/dashboards/${dashboardId}`, {
        dashboard: {
          components_attributes: [
            {
              id: dashboardComponentId,
              _destroy: true,
            },
          ],
        },
      });
    },
    ...options,
  });
}
